import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import { singleObjectAction, singleObjectActions, singleObjectInitialState } from '../../App/Ducks/SingleObject.duck';
import { newMercureMessage } from '../../App/Ducks/App.duck';
import { getAdminFurnitureType } from '../../App/Services/SettingsService';

export const actionTypes = {
  ResetData: '[Furniture] Reset Furniture',
  RequestData: '[Furniture] Request Furniture',
  FulfilledData: '[Furniture] Fulfilled Furniture',
};

const initialState = {
  ...singleObjectInitialState,
};

export const reducer = (state = initialState, action) => {
  const newState = singleObjectAction(actionTypes, state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export const actions = {
  ...singleObjectActions(actionTypes),
};

export function* saga() {
  yield takeLatest(actionTypes.RequestData, function* requestFurnitureSaga(action) {
    const response = yield getAdminFurnitureType(action.itemId);

    yield put(actions.fulfilledData(response.data));
  });

  yield takeEvery(newMercureMessage, function* execute(action) {
    if (typeof action.data['@type'] === 'string' && action.data['@type'] === 'FurnitureType') {
      yield put(actions.requestData());
    }
  });
}
